import React from 'react';

import './AINumber.scss';

export const OnboardingPaywallAINumber: React.FC = () => {
  return (
    <section className="onboarding-paywall-ai-number">
      <div className="onboarding-paywall-ai-number__wrapper">
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding-white/ai-number.png"
          alt="ai-number"
        />
      </div>
    </section>
  );
};
